import React, { useCallback } from "react";

import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import { DealsOrderBy } from "constants/deal";
import { useDealActions, useDealQueriesSelect } from "store";

const options: Record<DealsOrderBy, string> = {
  [DealsOrderBy.TITLE]: "Alphabetical Order",
  [DealsOrderBy.LAST_MODIFIED]: "Latest Update",
  [DealsOrderBy.LATEST_CREATED]: "Creation Date"
};

const textFieldStyles: TextFieldProps["sx"] = {
  minWidth: "191px",
  outline: "none",
  ".MuiInputBase-root": {
    bgcolor: "white",
    borderRadius: "40px",
    color: "black",
    fontSize: "16px"
  },
  ".MuiSelect-select": {
    p: "2px 9px 2px 0 !important"
  }
};

export const OrderBy: React.FC = () => {
  const { order_by } = useDealQueriesSelect();
  const { updateQueries } = useDealActions();

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      updateQueries({ order_by: value as DealsOrderBy }); // TS types issue, there is no way to describe value of event.target in the case
    },
    [updateQueries]
  );

  return (
    <TextField
      slotProps={{
        input: {
          startAdornment: <FilterListRoundedIcon sx={{ fontSize: "20px" }} />
        }
      }}
      sx={textFieldStyles}
      value={order_by}
      onChange={onChange}
      select
    >
      {Object.entries(options).map(([key, title]) => (
        <MenuItem key={key} value={key}>
          {title}
        </MenuItem>
      ))}
    </TextField>
  );
};
